import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD } from "services/commonService";

const SLICE = "Library";

const isLibraryThunk = (action: any) => action.type.startsWith(`${SLICE}/`);

const initialState: any = {
  loadingCount: 0,
  sharedLinkDetails: {}
};

export const postSharedLink = createAsyncThunk(`${SLICE}/postSharedLink`, (data: any, thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.postSharedLink, data, thunkApi)
);

export const getSharedLink = createAsyncThunk(`${SLICE}/getSharedLink`, (data: any, thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.getSharedLink, data, thunkApi, [], data)
);

export const Library = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSharedLink.fulfilled, (state, action: any) => {
        state.sharedLinkDetails = action.payload;
      })
      .addMatcher(
        (action) => isPending(action) && isLibraryThunk(action),
        (state) => {
          state.loadingCount += 1;
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isLibraryThunk(action),
        (state) => {
          state.loadingCount -= 1;
        }
      );
  }
});

export const {} = Library.actions;

export default Library.reducer;
